module.exports = "<span>\r\n    {{ $ctrl.date | date: $ctrl.format:($ctrl.date && !isNaN($ctrl.date) ? 'UTC' : undefined) }}\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-date/rw-date.html
// module id = 1912
// module chunks = 0